import { type FC } from 'react'
import classNames from 'classnames'
import { getAriaLabel } from 'shared/lib'
import styles from './styles.module.scss'
import { type IBadgeVariant, type IBadgeType } from './types'

export type IBadgeProps = {
  type?: IBadgeType
  variant?: IBadgeVariant
  content?: number
  showAll?: boolean
  size?: 'medium' | 'small' | 'large'
  isFullCount?: boolean
  isEmpty?: boolean
  ariaLabel?: string
  maxLimitContent?: 1_000 | 10_000
}

export const Badge: FC<IBadgeProps> = (props) => {
  const type = props.type || 'standard'
  const variant = props.variant || 'blue'
  const content = () => {
    if (!props.content) return 0
    if (props.isFullCount) return props.content
    if (props.maxLimitContent) {
      if (props.content < props.maxLimitContent) return props.content

      if (props.maxLimitContent === 1_000) return '1K+'
      if (props.maxLimitContent === 10_000) return '10K+'
    }
    if (props.content > 99) return '99+'

    return props.content
  }
  const showAll = props.showAll
  const size = props.size || 'medium'

  if (!content() && !showAll && !props.isEmpty) return null

  return (
    <div className={classNames(styles.wrap, styles[size])}>
      <div
        className={classNames(styles.count, styles[variant], styles[type])}
        aria-label={getAriaLabel(props.ariaLabel ?? '')}
      >
        {props.isEmpty ? null : content()}
      </div>
    </div>
  )
}
